"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDuplicates = exports.isArrayOfArrays = exports.flattenOnce = exports.shallowUnique = void 0;
function shallowUnique(list) {
    return [...new Set(list)];
}
exports.shallowUnique = shallowUnique;
function flattenOnce(list) {
    return list.reduce((acc, val) => acc.concat(val), []);
}
exports.flattenOnce = flattenOnce;
function isArrayOfArrays(list) {
    if (!Array.isArray(list)) {
        return false;
    }
    return list.every(Array.isArray);
}
exports.isArrayOfArrays = isArrayOfArrays;
/**
 * Removes duplicates from array.
 *
 * Preserves items order.
 */
function removeDuplicates(list, keyFn) {
    const seen = new Map();
    return list.filter((item) => {
        const key = keyFn ? keyFn(item) : item;
        if (seen.has(key)) {
            return false;
        }
        seen.set(key, true);
        return true;
    });
}
exports.removeDuplicates = removeDuplicates;
